import { CodeType } from '@cheqroom/web/@types/graphql.d';

import { requireEnv } from '../env';
// Use string literals directly to avoid runtime import issues with .d.ts files
// CodeType is a const enum with values: 'BARCODE', 'QRCODE', 'RFIDCODE'
const mapCodeTypetoBcid: Record<CodeType, string> = {
	BARCODE: 'code128',
	QRCODE: 'qrcode',
	RFIDCODE: 'rfidcode',
};

export const getCodeUrl = (kind: CodeType, value: string, width = 40, height = 40) => {
	const CODES_API_URL = requireEnv(process.env.CODES_API_URL, 'CODES_API_URL');

	const toMm = (px: number) => px * 0.2645833333;

	const url = new URL(CODES_API_URL);
	url.searchParams.append('bcid', mapCodeTypetoBcid[kind]);
	url.searchParams.append('text', value);
	url.searchParams.append('width', toMm(width).toString());
	url.searchParams.append('height', toMm(height).toString());

	return url.toString();
};
